import React from 'react';
import './therapies.css';

import imageAcupuncture from "./images/acupucture.jpg";
import imageFrequency from "./images/frequency.jpg";
import imageBiokybernetic from "./images/biokybernetic.png";
import imageFood from "./images/food.jpg";
import imageMassage from "./images/massage.jpg";


const Therapies = () => {
return(
<div className="section sectionBackground" id="therapies">
<div className="viewport">
                                <h1> Therapien </h1>
                                <div className='grid'>
                                    <div className='item'>
                                        <div className='image' style={{backgroundImage: `url(${imageAcupuncture}`}} />
                                        Traditionelle Chinesische Medizin

                                        </div>
                                        <div className='item'>
                                        <div className='image' style={{backgroundImage: `url(${imageFrequency}`}} />
                                        Frequenztherapie
                                        </div>
                                        <div className='item'>
                                        <div className='image' style={{backgroundImage: `url(${imageBiokybernetic}`, backgroundSize: `90%`}} />
                                        Biokybernetik nach Smit
                                        </div>
                                        <div className='item'>
                                        <div className='image' style={{backgroundImage: `url(${imageFood}`}} />
                                        Ernährungsberatung
                                        </div>
                                        <div className='item'>
                                        <div className='image' style={{backgroundImage: `url(${imageMassage}`}} />
                                        Bioenergetische Massage (Fohow),<br />
                                        Fußreflexzonen-Massage,<br />
                                        Schröpfkopfmassage
                                        </div>
                                        <div className='item'>
                                        <div className='image' />
                                        Entfernen von Hautanomalien<br />
                                        (Phlebolyser®)
                                        </div>
                                </div>
                        </div>

</div>
)
}
export default Therapies;